import type { IconProps } from "./types";

interface UpDownIconProps extends IconProps {
  order?: "asc" | "desc" | null;
}

export function UpDown({
  size = 24,
  color = "currentColor",
  order,
  ...props
}: UpDownIconProps) {
  const currentColor =
    color === "currentColor"
      ? color
      : color.includes("#")
        ? color
        : `var(--${color})`;
  const enableColor = "var(--labels-primary)";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.3582 3.83177C11.6955 3.4382 12.3044 3.4382 12.6418 3.83177L15.8756 7.60461C16.3456 8.15293 15.956 9 15.2338 9H8.76611C8.04394 9 7.65434 8.15293 8.12432 7.60461L11.3582 3.83177Z"
        fill={order === "asc" ? enableColor : currentColor}
      />
      <path
        d="M11.3582 20.1682C11.6955 20.5618 12.3044 20.5618 12.6418 20.1682L15.8756 16.3954C16.3456 15.8471 15.956 15 15.2338 15H8.76611C8.04394 15 7.65434 15.8471 8.12432 16.3954L11.3582 20.1682Z"
        fill={order === "desc" ? enableColor : currentColor}
      />
    </svg>
  );
}
